import React, { useState, useEffect } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import PropTypes from 'prop-types';
import { useToasts } from 'react-toast-notifications';
import { useQuery, useMutation } from 'react-apollo';
import { EditArtistDetail, EditManagerDetail } from '../../modals';
import { staticConstants, handleGraphqlError } from '../../../utils';
import Loading from '../../shared/loadingOverlay/Loading';
import { GET_USER_DATA_QUERY } from '../../../graphql-client/queries';
import { UPDATE_USER, LOADER_MUTATION } from '../../../graphql-client/mutations';

function EditProfileDetail(props) {
  const { addToast } = useToasts();
  const {
    isOpen, userRole, userId, updateUserList, managerObject,
  } = props;
  const [modal, setModal] = useState(isOpen);
  const [loaderMutate] = useMutation(LOADER_MUTATION, {
    variables: { show: false },
  });

  const {
    loading: getUserLoading, error, data, refetch: getUserRefetch,
  } = useQuery(
    GET_USER_DATA_QUERY, {
      variables: { userId },
      skip: (userRole === staticConstants.ROLE.MANAGER),
    },
  );

  useEffect(() => {
    if (userId) {
      getUserRefetch({ userId });
    }
  },
  [userId]);

  const toggle = () => {
    setModal(!modal);
    props.onClose(false);
  };

  const [updateProfileDetail] = useMutation(UPDATE_USER, {
    variables: {},
    onError(err) {
      loaderMutate({ variables: { show: false } });
      addToast(handleGraphqlError(err), { appearance: 'error' });
    },

    onCompleted(profileData) {
      loaderMutate({ variables: { show: false } });
      addToast(profileData.updateUser.message, { appearance: 'success' });
      toggle();
      updateUserList && updateUserList();
    },

  });

  if (getUserLoading) {
    return <Loading active />;
  }
  if (error) {
    return addToast(handleGraphqlError(error), { appearance: 'error' });
  }

  const onSubmitCallBack = (profileData) => {
    loaderMutate({ variables: { show: true } });
    updateProfileDetail({ variables: profileData });
  };

  return (
    <Modal
      isOpen
      toggle={toggle}
      className={`modal-edit-${userRole} modal-dialog-centered`}
      keyboard={false}
    >
      <ModalBody>
        {
          userRole === staticConstants.ROLE.MANAGER && managerObject
            && (
            <EditManagerDetail
              toggle={toggle}
              data={managerObject}
              submitCallBack={onSubmitCallBack}
            />
            )
        }
        {
          userRole === staticConstants.ROLE.ARTIST && data.getUser.data
            && (
            <EditArtistDetail
              toggle={toggle}
              data={data && data.getUser && data.getUser.data}
              submitCallBack={onSubmitCallBack}
              userId={userId}
            />
            )
        }
      </ModalBody>
    </Modal>
  );
}

EditProfileDetail.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  userRole: PropTypes.string.isRequired,
  userId: PropTypes.string,
  updateUserList: PropTypes.func,
  managerObject: PropTypes.object.isRequired,
};
EditProfileDetail.defaultProps = {
  userId: null,
  updateUserList: null,
};

export default EditProfileDetail;
